"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationA11yMixin = void 0;
var _styledComponents = require("styled-components");
/** @mixin animationA11yMixin */
/**
 * Adds an animation that will meet a11y standards.
 *
 * @example
 * import { animationA11yMixin } from '@zillow/constellation';
 *
 * const animationFadeInMixin = animationA11yMixin(
 *  ({ theme }) => css`
 *      animation: ${fadeInKeyframes} ${token('animations.defaultDuration')}s
 *          ${token('animations.defaultTimingFunction')};
 *  `
 * );
 *
 * const Component = styled.div`
 *     ${animationFadeInMixin}
 * `;
 *
 * <Component>My animated component</Component>
 *
 * @method
 * @param {CSSObject} styles - A styled-compoennts css object.
 * @return {CSSObject}
 */
var animationA11yMixin = function animationA11yMixin(styles) {
  return (0, _styledComponents.css)(["", " @media (prefers-reduced-motion:reduce){animation:none;}"], styles);
};
exports.animationA11yMixin = animationA11yMixin;